module.exports = __webpack_public_path__ + "static/media/teygja_fotapressa_a.ac32e027.png";